/* eslint-disable react-hooks/rules-of-hooks */
import React, { useState, useEffect, useRef, useContext } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { FitinsurAPI, MessageCenter } from 'utils';
import { GlobalAuthContext, GlobalOperationContext } from 'store/context';
import SelectField from '../Form/SelectField';
import ComboBox from '../Form/ComboBox3';
import { FastField, Field, FieldArray, Form, Formik } from 'formik';
import Button from "../Button";
import { LoaderContext } from '../../contexts';
import { useCreateRenewal, useLostOperation } from '../../services/OperationService';

import {
    Dialog,
    DialogBody,
    DialogIcon,
    DialogText,
    DialogSelect,
    ButtonsRow,
    DialogConfirm,
} from './styles';

const mc = new MessageCenter();
const fitinsurApi = new FitinsurAPI();

export default function ModalLost({
    idOperation,
    idDomain,
    show,
    setDialog,
    createAndLostOperation,
    operationThatReceivedLost,
    idQuestion,
    idProduct,
    title,
    redirectTo
}) {
    const [visible, setVisible] = useState(show);
    const [lostDeal, setLostDeal] = useState({ formatted: [], array: [] });
    const [idRenewalOperation, setIdRenewalOperation] = useState(null);

    const { updateIsLoadingStatus } = useContext(LoaderContext);
    const authContext = useContext(GlobalAuthContext);
    const myRef = useRef();
    const lostReasonsRef = useRef();

    const history = useHistory();
    const location = useLocation();

    const {
        data: useCreateRenewalData,
        loading: useCreateRenewalLoading,
        error: useCreateRenewalError,
        status: useCreateRenewalStatus,
        request: useCreateRenewalRequest,
    } = useCreateRenewal(idOperation);

    const {
        data: useLostOperationData,
        loading: useLostOperationLoading,
        error: useLostOperationError,
        status: useLostOperationStatus,
        request: useLostOperationRequest,
    } = useLostOperation(idRenewalOperation || idOperation);

    useEffect(() => {
        updateIsLoadingStatus(
            useLostOperationLoading ||
            useCreateRenewalLoading
        );
    }, [
        useLostOperationLoading,
        useCreateRenewalLoading
    ]);

    useEffect(() => {
        if (useCreateRenewalStatus === 200) {
            setIdRenewalOperation(useCreateRenewalData.value.idOperation)
        }
    }, [useCreateRenewalStatus]);

    useEffect(() => {
        if (idRenewalOperation) {
            useLostOperationRequest({
                idQuestion,
                idAnswerOption: lostReasonsRef.current.values.reasons
            })
        }
    }, [idRenewalOperation]);

    useEffect(() => {
        if (useLostOperationStatus === 200) {
            if (idDomain === 686) {
                location?.pathname === "/credit-analysis"
                    ? window.location.reload()
                    : history.push("/credit-analysis");
            } else if (createAndLostOperation) {
                operationThatReceivedLost(idOperation)
            } else if (redirectTo){
                history.push(redirectTo);
            } else {
                location?.pathname === "/quotes"
                    ? window.location.reload()
                    : history.push("/quotes");
            }
        }
    }, [useLostOperationStatus]);

    useEffect(() => {
        setVisible(show);
    }, [show]);


    useEffect(() => {
        async function request() {
            fitinsurApi.setAuthToken(authContext.token);
            const data = await fitinsurApi.requestLostDealList(idQuestion).then((response) => response.json());

            console.log("datadata", data)
            try {
                if (data.ret_code != 200) {
                    mc.error("fitGetLostReason - REQUEST ERROR => " + JSON.stringify(data))
                    console.log(data);
                    return;
                }

                if (data.ret_value) {
                    const formattedOptions = data.ret_value.map(listOption => {
                        let behavior = {};

                        try {
                            behavior = JSON.parse(listOption.BEHAVIOR || "{}")
                        } catch (e) {
                        }

                        if (behavior.resultIdProduct && idProduct) {
                            if (!behavior.resultIdProduct.includes(idProduct)) return null
                        }

                        return {
                            label: listOption.ANSWER_OPTION_DESCRIPTION,
                            value: listOption.ID_ANSWER_OPTION,
                        }
                    }).filter(v => v);
                    setLostDeal({ formatted: formattedOptions, array: data.ret_value });
                } else {
                    console.log("fitGetLostReason - UNEXPECTED NULL RETURNED DATA => " + JSON.stringify(data));
                }
            } catch (error) {
                mc.error("There was an error while fetching your data: \n" + error);
                console.error('fitGetLostReason - Error:', error);
                setLostDeal({ formatted: [{ label: 'Error', value: '' }], array: [] });
            };
        }

        request();
    }, [idProduct])

    const handleLostSubmit = (selectedID) => {
        if (!selectedID) {
            mc.error("Por favor, selecione o motivo do declínio");
            return;
        }

        if (createAndLostOperation) {
            useCreateRenewalRequest({ idDomain: 607 }, { lostRenewal: true });
        } else {
            useLostOperationRequest({
                idQuestion,
                idAnswerOption: selectedID
            });
        };
        setDialog(!show);
    }

    console.log("lostDeal", lostDeal)
    return (
        <Dialog canShow={visible} >
            <DialogBody ref={myRef}>
                <DialogIcon>
                    <DialogText>{title || 'DECLINADO'}</DialogText>
                </DialogIcon>
                <Formik
                    initialValues={{ reasons: '' }}
                    innerRef={lostReasonsRef}
                    onSubmit={(e) => { handleLostSubmit(e.reasons); }}
                >
                    <Form>
                        <DialogSelect>
                            <Field
                                disabled={false}
                                name="reasons"
                                placeholder="Selecione o motivo do declínio"
                                component={ComboBox}
                                options={lostDeal.formatted}
                            />
                        </DialogSelect>
                        <ButtonsRow>
                            <Button
                                third
                                type="button"
                                onClick={(e) => { e.preventDefault(); e.stopPropagation(); setDialog(false); lostReasonsRef.current.setFieldValue('reasons', ''); }}                        >
                                CANCELAR
                            </Button>
                            <Button
                                primary
                                type="submit"
                            >
                                CONFIRMAR
                            </Button>
                        </ButtonsRow>
                    </Form>
                </Formik>
            </DialogBody>
        </Dialog>
    );
}